import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';

/**
 * @interface interface for entry data
 */
export interface VerifyAddressInterface {
  addresses: Array<object>;
}

@Component({
    selector: 'app-verify-address',
    templateUrl: './verify-address.component.html',
    styleUrls: ['./verify-address.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, NgFor, MatDialogActions, MatButton]
})
export class VerifyAddressComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VerifyAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VerifyAddressInterface
  ) { }

  /**
    * @function ngOnInit Method to Initializes the component and perform initial operations
    */
  ngOnInit() { }
  /**
    * @function onCancel Method to close the modal with no address selected
    */
  public onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * @function selectAddress Method to close the modal with the selected address
   * @param address address selected
   */
  public selectAddress(address: object) {
    this.dialogRef.close(address);
  }

}
